import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

export const contactInfoValidation = Yup.object({
    primaryEmail: createValidationRule("email"),
    secondaryEmail:createValidationRule("email"),
    primaryContact: createValidationRule("phone"),
    secondaryContact:createValidationRule("phone"),
});
